module.exports = __webpack_public_path__ + "static/media/BMODE_60_50.802ff59c.jpg";